import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import institute_img from "../../../assets/Institute.svg";
import marker_img from "../../../assets/location_marker.svg";
import { TwButton, TwInputGroup, TwLocationInput, TwMainLayout } from "../../../components/tailwind";
import { useLocalStorage } from "../../../hooks";
import { LoadingBackdrop } from "../../../layouts";
import { useToast } from "../../../provider/ToastProvider";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import { setGlobalLoading, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import { userState } from "../../../redux/reducers/userReducer";
import { getUrlForServices } from "../../../utils/confighelpers";
import MyAvailableTimeForm from "../../settings/myAvailableTime/MyAvailableTimeForm";


const openDayAndTimeObject = [
  {
    day: "monday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "tuesday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "wednesday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "thursday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "friday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "saturday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
  {
    day: "sunday",
    isOpen: true,
    openTime: [
      {
        startTime: "9:00 AM",
        endTime: "05:00 PM",
      },
    ],
  },
];

const AddVenue = ({ navigation }) => {

  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const dashboardReduxState = useSelector(dashboardState);
  const [loadingDone, setLoadingDone] = React.useState(false);
  const [formErrors, setFormErrors] = React.useState({});
  const [venueDetails, setVenueDetails] = useState({
    venueName: "",
    validityStartDate: new Date(),
    validityEndDate: moment().add(30, 'days').format("YYYY-MM-DD"),
    scheduleWithoutValidity: false,
    openDayAndTime: openDayAndTimeObject
  });
  const [openDayAndTime, setOpenDayAndTime] = useState(openDayAndTimeObject);

  const userReduxState = useSelector(userState);
  const [address, setAddress] = useState(location.state !== null && location.state?.address ? location.state.address : {});
  const [userToken] = useLocalStorage("userToken");
  const [edit, setEdit] = React.useState(false);
  const [editValues, setEditValues] = React.useState({});

  const handleAddVenue = async () => {
    const errors = {};
    if (venueDetails.venueName === "") {
      errors.venueName = "Please enter venue name";
    }
    if (Object.keys(address).length === 0) {
      errors.venueAddress = "Please enter work location address";
    }
    openDayAndTime?.forEach((item) => {
      item?.openTime?.forEach((timings) => {
        if (!timings?.startTime || !timings?.endTime) {
          errors.startTime = "Please select timings";
        }
      });
    });
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast("Please enter correct details");
      return;
    }
    const payloadBody = {
      addedByUserId: userReduxState.userData?._id,
      venueName: venueDetails.venueName || "",
      about: "",
      scheduleWithoutValidity: venueDetails.scheduleWithoutValidity || false,
      validityStartDate: moment(venueDetails?.validityStartDate).format("YYYY-MM-DD"),
      validityEndDate: moment(venueDetails?.validityEndDate).format("YYYY-MM-DD"),
      address: address,
      openDayAndTime: venueDetails?.openDayAndTime,
      // busyDayAndTime: busyDayAndTime,
    };
    let config = {};
    if (edit) {
      config = {
        method: "post",
        url: `${getUrlForServices()}venue/update/${editValues._id}`,
        headers: {
          "x-access-token": userToken,
        },
        data: payloadBody,
      };
    } else {
      config = {
        method: "post",
        url: `${getUrlForServices()}venue/add`,
        headers: {
          "x-access-token": userToken,
        },
        data: payloadBody,
      };
    }
    dispatch(setGlobalLoading(true))
    const request = await axios(config);
    dispatch(setGlobalLoading(false))
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // addSuccessToast(request.data.message);
        addSuccessToast("Successfully uploaded");
        if (location.state?.from === "list") {
          navigation("/myvenue/");
        } else {
          navigation("/businessprofilesetup/done");
          // navigation("/businessprofilesetup/subscription");
        }
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  const renderLayout = (layoutType = "full", children) => {
    return layoutType == "full" ? (
      <LoadingBackdrop>
        <div>
          <div className="py-[35px] px-[46px] shadow-[0_4px_7px_-0px_rgba(0,0,0,0.02)]">
            <p className="text-brown-coffee text-4xl leading-[44px] font-extrabold">
              Add Your Business Hours
            </p>
          </div>
          <div className="grid w-full justify-items-center min-w-[1440px]">
            <div className={`sm:w-3/6 md:w-3/5 `}>
              {children}
            </div>
          </div>
        </div>
      </LoadingBackdrop>
    ) : (
      <TwMainLayout
        headTitle="Add new Venue"
        breadcrumbs={[
          { title: "My Venue", onClick: () => { navigation("/myvenue/"); } },
          { title: "Add new Venue" },
        ]}
        headActions={[
          ...(location.state?.from === "list") ? [(<TwButton
            className="hidden sm:flex sm:min-w-32"
            variant="orange-outline"
            onClick={() => {
              navigation("/myvenue/");
            }}
          >
            Cancel
          </TwButton>)] : [],
          (<TwButton
            className="hidden sm:flex sm:min-w-32"
            onClick={() => {
              handleAddVenue();
            }}
          >
            {edit ? "Update" : "Save"}
          </TwButton>),
        ]}
        footerClass="sm:flex md:hidden"
        footerActions={[
          ...(location.state?.from === "list") ? [(<TwButton
            className="sm:min-w-32"
            variant="orange-outline"
            onClick={() => {
              navigation("/myvenue/");
            }}
          >
            Cancel
          </TwButton>)] : [],
          (<TwButton
            className="sm:min-w-32"
            onClick={() => {
              handleAddVenue();
            }}
          >
            {edit ? "Update" : "Save"}
          </TwButton>),
        ]}
        children={children} />
    );
  }

  const getVenueInfo = async (id) => {
    dispatch(setSectionLoading(true));
    const config = {
      method: "get",
      url: `${getUrlForServices()}venue/list?venueId=${id}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axios(config);
    if (request.data.statusCode === 200) {
      let address = request.data.data.address;
      address.description = address.address;
      setVenueDetails(request.data.data);
      setAddress(address);
      setOpenDayAndTime(request.data.data.openDayAndTime)
      setEditValues((prevValues) => ({
        ...request.data.data
      }));
      setLoadingDone(true)
    }
    dispatch(setSectionLoading(false));
  }

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setVenueDetails((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  React.useEffect(() => {
    if (dashboardReduxState.venueId !== undefined && dashboardReduxState.venueId !== -1 && dashboardReduxState.venueId !== "") {
      setEdit(true)
      getVenueInfo(dashboardReduxState.venueId);
    }
  }, []);
  return (renderLayout(location.state?.from === "list" ? "section" : "full",
    (<div className="">
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="flex flex-col gap-5 sm:mx-auto sm:w-full sm:max-w-sm md:max-w-lg">
          <TwInputGroup
            label={"Venue Name"}
            placeholder={"Give a name to this work location"}
            name={"venueName"}
            leftIcon={(<img className={""} src={institute_img} alt={""} />)}
            value={venueDetails.venueName}
            onChange={handleFormValueChange}
            errors={formErrors}
          />
          <TwLocationInput
            label={"Work Location Address"}
            name={"venueAddress"}
            leftIcon={(<img className={""} src={marker_img} alt={""} />)}
            defaultLocationSelect={address}
            onLocationSelect={(data) => {
              setAddress(data);
            }}
            errors={formErrors}
          />
          {location.state?.from === "registration" && <MyAvailableTimeForm
            profileDetails={venueDetails}
            setProfileDetails={setVenueDetails}
            reloadData={loadingDone}
          />}
        </div>
      </div>
    </div>
    ))
  );
};

export default AddVenue;
